import './LoginConfirmation.scss'
import {useState} from "react"
import { Field, Input, Button, Spinner } from "@fluentui/react-components";
import { verifyLoginCode } from '../../services/login.service';
import { useAuth } from '../../auth/AuthProvider';
import { useNavigate } from "react-router-dom";

function LoginConfirmation({email})
{
    const userEmail = email;
    const [confirmationCode, setConfirmationCode] = useState(null);
    const [loading, setLoading] = useState(false);
    const [enableLoginButton, setEnableLoginButton] = useState(true);   
    const {login} = useAuth();
    const navigate = useNavigate();

    async function CheckConfirmationCode()
    {
        if(userEmail && confirmationCode)
        {
            setLoading(true);                           
            setEnableLoginButton(false);            
            const data = await verifyLoginCode(
                email, confirmationCode, {timeoutMs: 10000}
                )
                .then((response) => {                       
                    if(response)
                    {
                        login({user:email, token:response});
                    }
                })            
                .catch(ex => {
                    console.log(ex);
                })
                .finally(() => {                    
                    setLoading(false);
                    setEnableLoginButton(true);
                });
        }
    }

    return (
        userEmail && 
        <div className='container'>
            <div className='d-flex justify-content-center'>
                <div className='row'>
                    <div className='offset-md-2 col-md-8 offset-md-2'>
                        <h3>Please check your email: <strong>{userEmail}</strong> for confirmation code</h3>
                        <Field validationState={!confirmationCode && 'error'} validationMessage={!confirmationCode && "Code required"} size="large" required>
                            <Input placeholder='- - - - - -' aria-label='Confirmation Code' onChange={(event) => setConfirmationCode(event.target.value)}/>
                        </Field>
                        {loading && <Spinner labelPosition='before' label="Verifiying login code..." />} 
                    </div>                
                </div>
            </div>
            <br/>            
            <div className='d-flex justify-content-center'>
                <div className='row'>
                    <div className='col-md-12'>
                        <Button disabledFocusable={!enableLoginButton || !confirmationCode} appearance='primary' shape="circular"
                        onClick={() => CheckConfirmationCode()}>Login</Button>
                    </div>                
                </div>
            </div>
        </div>
    );
}

export default LoginConfirmation;